// src/services/listingService.js
export async function getListings() {
  const res = await fetch('https://crm-api.aigents.services/api/v1/default_client/listings?crm_source=hubspot'); // Updated URL
  if (!res.ok) {
    const errorBody = await res.text();
    console.error('Failed to fetch listings:', res.status, errorBody);
    throw new Error(`Failed to fetch listings. Status: ${res.status}. Body: ${errorBody}`);
  }
  const data = await res.json();
  return data.listings; // Ensure you return the array of listings
}
